import { render } from "./MagicButton.ce.vue?vue&type=template&id=e1faf5c6"
import script from "./MagicButton.ce.vue?vue&type=script&lang=js"
export * from "./MagicButton.ce.vue?vue&type=script&lang=js"

import _style_0 from "./MagicButton.ce.vue?vue&type=style&index=0&id=e1faf5c6&inline&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__